import { render, staticRenderFns } from "./CurrentPlanCard.vue?vue&type=template&id=20854470"
import script from "./CurrentPlanCard.vue?vue&type=script&lang=js"
export * from "./CurrentPlanCard.vue?vue&type=script&lang=js"
import style0 from "./CurrentPlanCard.vue?vue&type=style&index=0&id=20854470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports